import React, {useState, useEffect, useContext} from 'react';
import { NotificationList } from '../../components/notifications/notificationList';
import { APIGetNotifications } from '../../api/notifications/Notifications';
import { UserContext } from '../../context/UserContext';

export const Notifications = () => {
    const { user } = useContext(UserContext);
    const [notifications, setNotifications] = useState(null);

    useEffect(() => {
        APIGetNotifications(user?.id).then((nots) => {
            setNotifications(nots);
        });
    }, [user?.id]);


    return (
        <div className={"mx-auto bg-gray-100  max-w-7xl px-4 "}>
            <main>
                <div className="w-full flex">
                    <NotificationList notifications={notifications}/>
                </div>
            </main>
        </div>
    )

}
